import {
  datastarMergePatchForMapPagePatch,
} from "./map-page-signals.js";
import {
  mapShellProjectionV1FromSignals,
  mapShellSignalStateV1FromProjection,
} from "./map-shell-projection.js";

export const MAP_DATASTAR_SIGNAL_FILTER = Object.freeze({
  include: /^_(?:map_[^.]+|shared_fish)(?:\.|$)/,
});

export const DATASTAR_BROWSER_BUNDLE_SELECTOR =
  "script[type='module'][data-fishystuff-datastar-bundle]";

function assertDatastarModule(module) {
  if (
    !module
    || typeof module.filtered !== "function"
    || typeof module.mergePatch !== "function"
  ) {
    throw new TypeError(
      "The map signal adapter requires Datastar's public filtered and mergePatch exports",
    );
  }
  return module;
}

export function createMapDatastarSignalAdapter(datastarModule) {
  const { filtered, mergePatch } = assertDatastarModule(datastarModule);

  function snapshot() {
    return mapShellSignalStateV1FromProjection(
      mapShellProjectionV1FromSignals(filtered(MAP_DATASTAR_SIGNAL_FILTER)),
    );
  }

  return Object.freeze({
    snapshot,
    apply(currentSignals, patch) {
      const datastarPatch = datastarMergePatchForMapPagePatch(
        currentSignals,
        patch,
      );
      if (Object.keys(datastarPatch).length > 0) {
        mergePatch(datastarPatch);
      }
    },
  });
}

export async function loadMapDatastarSignalAdapter({
  documentRef = globalThis.document,
  importModule = (url) => import(url),
} = {}) {
  const bundle = documentRef?.querySelector?.(DATASTAR_BROWSER_BUNDLE_SELECTOR);
  const bundleUrl = String(bundle?.src || "").trim();
  if (!bundleUrl) {
    throw new Error("The marked Datastar browser bundle is unavailable");
  }
  return createMapDatastarSignalAdapter(await importModule(bundleUrl));
}
